export default {
  container: {
    "max-width": "180px",
    height: "auto",
    "margin-bottom": "20px",
  },
};
